import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import Navbar from "../Navbar/Navbar";

const Layout = ({ children, active = "DASHBOARD" }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Close mobile menu when clicking outside or navigating
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen && !event.target.closest('.mobile-nav-content') && !event.target.closest('.mobile-hamburger-btn')) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileMenuOpen]);

  return (
    <div className="layout-wrapper">
      {/* Mobile Hamburger Menu */}
      {isMobile && (
        <div className="mobile-hamburger-container">
          <button
            className="mobile-hamburger-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
          </button>
        </div>
      )}

      {/* Desktop Navigation */}
      {!isMobile && (
        <div className="desktop-nav">
          <Navbar
            onCollapse={(inactive) => {
              setInactive(inactive);
            }}
            active={active}
          />
        </div>
      )}

      {/* Mobile Navigation Overlay */}
      {isMobile && mobileMenuOpen && (
        <div className="mobile-nav-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-nav-content" onClick={(e) => e.stopPropagation()}>
            <Navbar
              onCollapse={(inactive) => {
                setInactive(inactive);
              }}
              active={active}
              isMobile={true}
              onMobileMenuClose={() => setMobileMenuOpen(false)}
            />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className={`layout-content ${!isMobile && inactive ? "inactive" : "active"} ${isMobile ? "mobile" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default Layout;
